import React, { useState, useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const FeatureDialog = React.memo(({ openDialog, handleCancel, handleConfirm }) => {
    const [localName, setLocalName] = useState("");
    const [sending, setSending] = useState(false);

    const handleConfirmClick = async () => {
        setSending(true)
        await handleConfirm(localName);
        setSending(false)
        setLocalName("");
    };


    return (
        <Dialog
            open={openDialog}
            onClose={handleCancel}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title">Confirmación</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-dialog-description">
                    ¿Deseas crear esta forma? Ingresa un nombre para identificarla.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Nombre de la forma"
                    fullWidth
                    variant="standard"
                    value={localName}
                    onChange={e => setLocalName(e.target.value.trim())}
                />
            </DialogContent>
            <DialogActions className='flex flex-col mb-3'>
                <div className='flex flex-row w-full justify-end'><Button onClick={handleCancel} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleConfirmClick} color="primary" disabled={!localName.trim() || sending}>
                    Confirmar

                </Button></div>

                <div>{ sending && (<CircularProgress />)}</div>
                    
            </DialogActions>
        </Dialog>
    );
});

export default FeatureDialog;
